<div
  *ngIf="parentFormGroup.controls[controlName]"
  class="font-work-sans font-regular {{screenType}}"
>
<div
*ngIf="label"

class="form-field-label {{type}} flex flex-row justify-between"
>
<div class="label flex flex-row content-center">
  {{ label }}
  <span
    *ngIf="isRequired"
    class="required-mark ml-[0.3rem]"
  >*</span>
  <app-icon
    *ngIf="tooltipText"
    [matTooltip]="tooltipText"
    class="tooltip-icon"
    matTooltipClass="custom-tooltip"
    matTooltipPosition="below"
    svgIcon="info"
  />
</div>
</div>
  <div>
    <mat-form-field
      [formGroup]="parentFormGroup"
      [ngClass]="{
        'enabled-clear-selection': enableClearSelection &&
                                   parentFormGroup.controls[controlName].value &&
                                   parentFormGroup.controls[controlName].status !== 'DISABLED',
        'small': type
      }"
      appearance="outline"
      class="form-field w-full"
      hideRequiredMarker
    >
      <mat-select
        #select
        [formControlName]="controlName"
        [multiple]="enableMultiple"
        class="select {{type}}"
        [ngClass]="{
            'enabled-clear-selections': (parentFormGroup.controls[controlName].status !== 'DISABLED') &&
            (enableClearSelection && parentFormGroup.getRawValue()[controlName])
          }"
        [panelClass]="optionsPanelClassName"
        [placeholder]="placeholder"
      >
        <mat-option
          *ngIf="loading; else loaded"
          class="dropdown-loading"
          disabled
        >
          <mat-spinner
            class="dropdown-loader"
            mode="indeterminate"
            [diameter]="20"
          >
          </mat-spinner>
        </mat-option>
        <ng-template #loaded>
          <div *ngIf="options?.length; else noData">
            <mat-option
              *ngFor="let option of options; let i = index"
              [value]="option.key"
              [disabled]="disableAllOptions || option.disabled || (optionsDisabled && option.key !== selectedSpecialOption)"
              class="single-select-option"
              [ngClass]="type ? 'small' : ''"
            >
              {{option.value}}
            </mat-option>
          </div>
          <ng-template #noData>
            <mat-option
              class="no-data"
              disabled>
              No options available
            </mat-option>
          </ng-template>
        </ng-template>
      </mat-select>
      <mat-icon
        (click)="clearSelection($event)"
        *ngIf="
          defaultValue && defaultValue.length ?
          (
             parentFormGroup.getRawValue()[controlName]?.join(',') !==
             defaultValue.join(',')
          ) : (
            (parentFormGroup.controls[this.controlName].status !== 'DISABLED') &&
            (
              (!enableMultiple && enableClearSelection && parentFormGroup.getRawValue()[controlName]) ||
              (enableMultiple && enableClearSelection && parentFormGroup.getRawValue()[controlName]?.length)
            )
          )"
        class="clear-selection text-palo-verde"
        matSuffix
        matTooltip="Clear"
      >close
      </mat-icon>
      <mat-error *ngIf="error">{{error}}</mat-error>
    </mat-form-field>
  </div>
</div>
